import {isNaN} from "lodash/lang";

export const isObjectEmpty
  = (obj) => Object.keys(obj).length === 0;

export const removeKeysFromObjectWithEmptyOrNullOrUndefinedValue = (object) => {
  Object
    .entries(object)
    .forEach(([k, v]) => {
      if (v && typeof v === 'object') {
        removeKeysFromObjectWithEmptyOrNullOrUndefinedValue(v);
      }
      if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined || v === "") {
        if (Array.isArray(object)) {
          object.splice(k, 1);
        } else {
          delete object[k];
        }
      }
    });
  return object;
};


export const mapAndParseObjectValueToNumberIfPossible = (object) => {
  return object?.map((val) =>
    Object.fromEntries(
      Object.entries(val).map(
        ([k, v]) => (v && !isNaN(parseFloat(v))) ? [k, parseFloat(v)] : [k, v])));
};

export const mapAndFilterUndefinedValues = (object) => {
  return object?.map((price) => Object.fromEntries(
    Object.entries(price).filter(([k, v]) => v !== undefined && !isNaN(parseFloat(v)))
  ));
};

export const ifNaNReturnUndefined = (val) => isNaN(val) ? undefined : val;

export const trimObject = (obj) => {
  if (!Array.isArray(obj) && typeof obj != 'object') return obj;
  return Object.keys(obj).reduce(function (acc, key) {
    acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : trimObject(obj[key]);
    return acc;
  }, Array.isArray(obj) ? [] : {});
};